import { ViewModelForm } from "@xengage/gw-portals-viewmodel-react";
import React, { useCallback, useContext, useEffect, useState } from "react";
import cx from 'classnames'
import { Flex } from '@jutro/layout'
import { IntlContext, TranslatorContext } from "@jutro/locale";
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { ClausesComponentVM } from 'ent-components-platform-react';
import BuildingSummaryAccordion from "../BuildingSummaryAccordion/BuildingSummaryAccordion";
import styles from '../TWIABuildingSummaryAccordions/TWIABuildingSummaryAccordions.module.scss';
import messages from '../TWIABuildingSummaryAccordions/TWIABuildingLocationAccordion/TWIABuildingLocationAccordion.messages'
import metadata from './TWIAPolicySummary.metadata.json';


function TWIAPolicySummary(props) {

    const {isQuotePage, submissionVM, onEditCoverage } = props
    const translator = useContext(TranslatorContext)
    const [locations, setLocations] = useState(submissionVM.lobData.commercialProperty.coverables.locations)
    const [locationPremium,setLocationPremium] = useState()
    const intlContext = useContext(IntlContext);
    const periodEndDate = _.get(submissionVM, `baseData.periodEndDate.value`);
    const periodStartDate = _.get(submissionVM, `baseData.periodStartDate.value`);

    // US28766 and US28769
    const updateLocPremium = useCallback((location)=>{
        let totalLocationPremium = 0;
        let currency;

        const totalPremium = location.value.buildings.map((tp)=>{
            totalLocationPremium += tp.premium.amount
            currency = tp.premium.currency
        })

        const formatterCurrency = intlContext.formatNumber(totalLocationPremium, {
            style: 'currency',
            currency: currency,
        });

        return formatterCurrency;
       
    },[locationPremium])

    const locationHeader = ( data,  name, locPremium) => {
        return(
            <div>               
                <Flex className={styles.fullWidth}>
                    <div className={cx(styles.heading, styles.headingBold, styles.flexOneThird)}>{translator(messages.locationHeading)}&nbsp;&nbsp;{_.get(data, 'locationNum_TWIA.value')}</div>
                    <div className={cx(styles.heading, styles.flexOneThird)}>{name}</div>
                    <div className={cx(styles.heading, styles.flexOneThird, styles.displayPremium)}>{locPremium}</div>
                </Flex>
            </div>
        ) 
    }

    const onEditCoveragePrevious = useCallback(() => {
        onEditCoverage()
    },[]);

    const generateTopicOverrides = useCallback(() => {
        const overrides = locations.children.map((data, i) => {
            
                return {
                    [`locationCard${i}`]: {
                        title: locationHeader( data, data.displayName.value, updateLocPremium(data)),
                    },
                }
            
        });

        return Object.assign({},...overrides);
    }, [ ]);

    const resolvers = {
        resolveCallbackMap: {
            updateLocPremium,
            onEditCoveragePrevious
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            clausesComponentVM: ClausesComponentVM,
            BuildingSummaryAccordion: BuildingSummaryAccordion
        },
    }

    const overrideProps = {
        locationAccordion: {
            data:  locations.children,
        },
        mailingSummary:{
            visible:!isQuotePage
        },
        editCoverageButton:{
            visible:isQuotePage
        },
        totalPremium: {
            value: {
                amount: _.get(submissionVM, 'quoteData.offeredQuotes.value[0].premium.total.amount'),
                currency: "USD"
            }
        },
        policyPeriod: {
            value: {
                startDate: periodStartDate,
                endDate: periodEndDate,
            },
        },
        policySummary:{
            visible:isQuotePage
        },
        ...generateTopicOverrides(),
        
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={submissionVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    )

}

export default TWIAPolicySummary